'use client';

import React, { useEffect, useRef } from 'react';



export default function AboutSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal-on-scroll')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  const teamImages = [
  { src: '/assets/images/39EA19B6-46A1-4A0A-B47B-85AF3EBE1AA6-1781229078063.png', alt: 'ALLYWRK team member on location shoot' },
  { src: '/assets/images/IMG_2465-1778375912713.jpg', alt: 'ALLYWRK photographer capturing editorial content' },
  { src: '/assets/images/IMG_2466-1778330519054.JPG', alt: 'ALLYWRK videographer on set' },
  { src: '/assets/images/IMG_2467-1778330681556.JPG', alt: 'ALLYWRK production team at work' },
  { src: '/assets/images/IMG_2469-1778330891510.JPG', alt: 'ALLYWRK crew member during live event' },
  { src: '/assets/images/IMG_2471-1778331704093.JPG', alt: 'ALLYWRK creative director reviewing footage' }];


  return (
    <section
      ref={sectionRef}
      id="about"
      style={{ background: '#0A0A0A', padding: '130px 0' }}>

      <div className="max-w-7xl mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 gap-16 lg:gap-24 items-start">
          {/* Left: Content */}
          <div className="reveal-on-scroll">
            <div className="section-label" style={{ color: 'white' }}>ABOUT THE TEAM</div>
            <h2
              className="text-white"
              style={{
                fontFamily: 'Bebas Neue, sans-serif',
                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                lineHeight: 0.95,
                letterSpacing: '2px',
                marginBottom: '24px'
              }}>

              MORE THAN A NAME.{' '}
              <span style={{ color: '#FFFFFF' }}>IT&apos;S OUR APPROACH.</span>
            </h2>
            <p
              style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '15px',
                color: 'rgba(255,255,255,0.6)',
                lineHeight: 1.75,
                marginBottom: '20px'
              }}>

              ALLYWRK is a creative production company built on purpose and precision. We specialize in photography, videography, live production, and branding — delivering consistent, high-quality work across every service.&nbsp;
            </p>
            <p
              style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '15px',
                color: 'rgba(255,255,255,0.5)',
                lineHeight: 1.75,
                marginBottom: '40px'
              }}>Our process starts before the cameras do. We ask the right questions, show up prepared, and follow through on every commitment. The result is work that represents our clients the way they deserve to be represented.


            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-12">
              {[
              { num: '100+', label: 'Projects' },
              { num: '4', label: 'Services' }]?.
              map((stat, i) =>
              <div key={i}>
                  <div
                  style={{
                    fontFamily: 'Bebas Neue, sans-serif',
                    fontSize: '40px',
                    letterSpacing: '2px',
                    color: '#FFFFFF',
                    lineHeight: 1,
                    marginBottom: '6px'
                  }}>

                    {stat?.num}
                  </div>
                  <div
                  style={{
                    fontFamily: 'DM Sans, sans-serif',
                    fontSize: '12px',
                    color: 'rgba(255,255,255,0.4)',
                    letterSpacing: '1px'
                  }}>

                    {stat?.label}
                  </div>
                </div>
              )}
            </div>

            {/* Blockquote */}
            <blockquote
              style={{
                borderLeft: '3px solid #FFFFFF',
                paddingLeft: '20px',
                marginBottom: '40px'
              }}>

              <p
                style={{
                  fontFamily: 'Bebas Neue, sans-serif',
                  fontSize: '20px',
                  letterSpacing: '3px',
                  color: 'rgba(255,255,255,0.7)',
                  lineHeight: 1.4
                }}>

                WE SHOW UP.<br />
                WE DELIVER.<br />
                THE WORK DOES THE REST.
              </p>
            </blockquote>

          </div>
        </div>
      </div>
    </section>);

}